export default "__VITE_ASSET__yUp_ZpC5__"